export default __webpack_public_path__ + "static/color-role-dont-light-381f0648af2f3b44a2637df0b14a3b93.png";